export default {"src":"/_next/static/media/instagram-icon.2866ded4.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};